export class AppSettings {

  
/********************* Prod  ******************************/
 static readonly SSO_URL =
 "https://sso.dsv.com/auth/realms/LLP/protocol/openid-connect/auth?response_type=code&client_id=LLPortal&scope=openid%20profile&redirect_uri=https://lead-logistics-api.dsv.com/User/SSoLogin";  

 static readonly API_URL = "https://lead-logistics-api.dsv.com/";  

/*********************/


/********************* Beta  ******************************
 static readonly SSO_URL =
 "https://ppr.sso.dsv.com/auth/realms/LLP/protocol/openid-connect/auth?response_type=code&client_id=LLPortal-ppr&scope=openid%20profile&redirect_uri=https://beta.lead-logistics-api.dsv.com/User/SSoLogin";  

 static readonly API_URL = "https://beta.lead-logistics.dsv.com/";  

*********************/

/********************* QA  ******************************
 static readonly SSO_URL =
 "https://qa.sso.dsv.com/auth/realms/LLP/protocol/openid-connect/auth?response_type=code&client_id=LLPortal-qa&scope=openid%20profile&redirect_uri=https://qa.lead-logistics-api.dsv.com/User/SSoLogin";  

 static readonly API_URL = "https://qa.lead-logistics-api.dsv.com/";  

*********************/


/********************* Test  ******************************
    static readonly SSO_URL =
        "https://ppr.sso.dsv.com/auth/realms/LLP/protocol/openid-connect/auth?response_type=code&client_id=LLPortal-test&scope=openid%20profile&redirect_uri=https://test.lead-logistics-api.dsv.com/User/SSoLogin";  
    
    static readonly API_URL = "https://test.lead-logistics-api.dsv.com/"; //Test 
  
  ******************************/

/********************* Dev  ******************************
 static readonly SSO_URL =
 "https://ppr.sso.dsv.com/auth/realms/LLP/protocol/openid-connect/auth?response_type=code&client_id=LLPortal-dev&scope=openid%20profile&redirect_uri=https://dev.lead-logistics-api.dsv.com/User/SSoLogin";  

  static readonly API_URL = "https://dev.lead-logistics-api.dsv.com/";  
******************************/


  static readonly IsDMZ = true;
}
